export default() => {
    if (typeof window === 'undefined') {
        return {};
    }

    let   match,
          pl     = /\+/g,  // Regex for replacing addition symbol with a space
          search = /([^&=]+)=?([^&]*)/g,
          decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
          query  = window.location.search.substring(1);

    const urlParams = {};
    while (match = search.exec(query)) {
        urlParams[decode(match[1])] = decode(match[2]);
    }
    return urlParams;
}



// WEBPACK FOOTER //
// /home/eric/projects/com.strongproject/repos/platforms/common-js/helpers/queryString.js